import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';

class TransactionReport extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            pendingInvoicePaymentList: [],
            tableStatus: "",
            partyDropdownList: [],
            totalPendingAmount: 0,
            filterDetails: {
                partyId: "",
                searchFor: "pendingPayment",
                filterBy: "all",
            },
            searchForList: [
                { searchFor: 'Pending Payment', value: 'pendingPayment' },
                { searchFor: 'Pending Invoice', value: 'pendingInvoice' },
            ],
            filterByList: [
                { filterBy: 'All', value: 'all' },
                { filterBy: 'Remaining', value: 'remaining' },
                { filterBy: 'Done', value: 'done' },
            ],
        };
    }

    componentDidMount() {
        this.getAllPendingInvoicePaymentReport()
    }

    getAllPendingInvoicePaymentReport = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllPendingInvoicePaymentReport(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Data Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                let totalPendingAmount = response.responseData.reduce((sum, item) => sum + (item.pendingAmount ? item.pendingAmount : 0), 0);
                this.setState({ pendingInvoicePaymentList: response.responseData, totalPendingAmount: totalPendingAmount }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown()
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                res = res.filter((item) => item.maintainAc === "B")
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    maintainAc: item.maintainAc,
                }));
                this.setState({ partyDropdownList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    handleDropdownChange = (e, name, section) => {
        const value = e.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details }, () => {
            this.getAllPendingInvoicePaymentReport()
        })
    };

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.filterDetails;
        details[drpIdentity] = selected.value;
        this.setState({ filterDetails: details }, () => {
            this.getAllPendingInvoicePaymentReport()
        });
    };

    resetForm = () => {
        let details = this.state.filterDetails;
        details.partyId = "";
        details.searchFor = "pendingPayment";
        this.setState({ filterDetails: details }, () => {
            this.getAllPendingInvoicePaymentReport()
        })
    }

    // Receipt Entry -> Payment Getting 
    // Payment Entry -> Payment Give to Party

    render() {
        return (
            <div className="transactionReport-page">

                <>
                    <div className="item-search mb-3.5">
                        <div className="item-grp !flex !gap-2.5 mb-3.5">
                            <div className="search-grp !min-w-[40%]">
                                <div className="item-search-box ">
                                    <label>Party Name</label>
                                    <MultiSelectDropdown
                                        drpIdentity="partyId"
                                        options={this.state.partyDropdownList}
                                        // className={` ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "partyId")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.partyDropdownList.filter(
                                            (party) =>
                                                party.value === this.state.filterDetails.partyId
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="dropdown-grp w-full">
                                <label>Search For</label>
                                <select
                                    value={this.state.filterDetails.searchFor}
                                    onChange={(e) =>
                                        this.handleDropdownChange(e, "searchFor", "filterDetails")
                                    }
                                >
                                    {this.state.searchForList.map((x, key) => (
                                        <option key={key} value={x.value}>
                                            {x.searchFor}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="btn-grp mt-auto w-full">
                                {/* <button
                                    className="add-btn mt-auto"
                                    onClick={() => this.getAllPendingInvoicePaymentReport()}>
                                    Search
                                </button> */}
                                <button
                                    className="cancel-btn mt-auto"
                                    onClick={() => this.resetForm()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="itemList-table">
                        <div className="table-container " style={{ height: "calc(100vh - 220px)" }} >
                            <table className="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[8%]'>Sr.No.</td>
                                        <td className='w-[12%]'>Date</td>
                                        <td className='w-[15%]'>Invoice No.</td>
                                        <td className='w-[35%]'>Party Name</td>
                                        <td className='w-[15%]'>Amount</td>
                                        <td className='w-[15%]'>Pending Amount</td>

                                    </tr>
                                </thead>
                                {this.state.pendingInvoicePaymentList && this.state.pendingInvoicePaymentList.length > 0 ? (
                                    this.state.pendingInvoicePaymentList.map((item, key) => (
                                        <tbody key={key}>
                                            <tr>
                                                <td>{key + 1}</td>
                                                <td>{moment(item.invoiceDate).format('DD MMM yyyy')}</td>
                                                <td>{item.invoiceNo}</td>
                                                <td>{item.partyId.partyName}</td>
                                                <td>{item.grandTotal}</td>
                                                <td>{item.pendingAmount}</td>
                                            </tr>
                                        </tbody>
                                    ))
                                ) : this.state.pendingInvoicePaymentList &&
                                    this.state.pendingInvoicePaymentList.length === 0
                                    && this.state.tableStatus !== "" ? (
                                    <tr>
                                        <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                            {this.state.tableStatus}
                                        </td>
                                    </tr>
                                ) : this.state.pendingInvoicePaymentList &&
                                    this.state.pendingInvoicePaymentList.length === 0
                                    && this.state.tableStatus === "" ? null : ""}
                            </table>
                        </div>
                    </div>
                    <div className="item-sections w-[22%] rounded-[10px] ml-auto mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                        <div className='flex gap-2.5 '>
                            <div className=" w-full">
                                <label>Total Amount</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="totalPendingAmount"
                                    name="totalPendingAmount"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.totalPendingAmount}
                                />
                            </div>
                        </div>
                    </div>
                </>
            </div >
        );
    }
}

export default TransactionReport;